"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaCurso = exports.yupCurso = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
exports.yupCurso = yup.object({
    idEmpresa: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Empresa'),
    idPeriodo: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Período'),
    idProximoCurso: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Próximo Curso'),
    idCoordenador: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Coordenador'),
    nome: yup.string().default('').max(35).required().label('Nome'),
    nomeAbrev: yup.string().default('').max(16, 'Máximo de 16 caracteres.').label('Nome Abreviado'),
    serieInic: yup.string().default('').max(1).required().label('Série Inicial'),
    serieFim: yup.string().default('').max(1).required().label('Série Final'),
    grau: yup
        .mixed()
        .oneOf(Object.values(enums_1.ECursoGrau))
        .default(enums_1.ECursoGrau.Fundamental)
        .required()
        .label('Nível'),
    tipoAva: yup.number().oneOf([0, 1]).default(0).label('Formula Cálculo Avaliação'),
    valor: yup.number().default(0).label('Valor da Mensalidade'),
    valorEntrada: yup.number().default(0).label('Valor da Entrada'),
    valorMaterial: yup.number().default(0).label('Valor do Material'),
    descVrdia: yup.number().default(0).label('Desconto para pagamento em dia'),
    habilita: yup.string().default('').label('Habilitação').max(80, 'Máximo de 80 caracteres.'),
    cargatotal: yup.number().default(0).label('Cargar horária total do curso'),
    contrato: yup.string().default('').max(30).label('Nome Contrato'),
    tipocurso: yup
        .mixed()
        .oneOf(Object.values(enums_1.ECursoTipoCurso))
        .default(enums_1.ECursoTipoCurso.Normal)
        .label('Tipo Curso'),
    parcelas: yup.number().default(0).label('Número Parcelas'),
    recCurso: yup.string().default('').label('Reconhecimento').max(35, 'Máximo de 35 caracteres.'),
    autoriza: yup.string().default('').max(35, 'Máximo de 35 caracteres.').label('Autorização'),
    renova: yup.string().default('').label('Renovação').max(35, 'Máximo de 35 caracteres.'),
    totalHa: yup.number().default(0).label('Total de horas aula'),
    maxRec: yup.number().default(0).label('Máximo de matrícula em recuperação'),
    numDp: yup.number().default(0).label('Número de dependências'),
    mediaAp: yup.number().default(0).label('Média para aprovação'),
    mediaRec: yup.number().default(0).label('Média para recuperação paralela'),
    mediaMin: yup.number().default(0).label('Média minima para entrar na recuparação'),
    mediaBim: yup.number().default(0).label('Média para aprovação no exame'),
    tipoava: yup.string().default('N').oneOf(['N', 'M']).label('Forma Exibição Avaliação'),
    externo: yup.boolean().required().default(false).label('Curso Externo'),
    tabdescuni: yup.boolean().required().default(false).label('Tabela de descontos'),
    apDp: yup.boolean().required().default(false).label('Aprovar aluno com Dependência'),
    avaPerson: yup.boolean().required().default(false).label('avaPerson'),
    jurPerson: yup.boolean().required().default(false).label('jurPerson'),
    descperson: yup.boolean().required().default(false).label('descperson'),
    multa: yup.number().default(0),
    juros: yup.number().default(0),
    fcalcjuros: yup.string().default(''),
    obshistesc: yup.string().default('').max(1200, 'Máximo de 1200 caracteres.'),
    fund9anos: yup.boolean().required().default(false).label('Ensino Fundamental de 9 anos'),
    mednormal: yup.boolean().required().default(false).label('mednormal'),
    diasantes: yup.boolean().required().default(false).label('diasantes'),
    atitudes: yup.boolean().required().default(false).label('atitudes'),
    marfin: yup.boolean().required().default(false).label('marfin'),
    bolDesc: yup.boolean().required().default(false).label('bolDesc'),
    series: yup.array().default([]),
    // --> Produtos do Curso [Mensalidade - Material - Entrada]
    idProdutoMensalidade: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Produto de Mensalidade'),
    idProdutoMaterial: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Produto de Material'),
    idProdutoEntrada: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Produto de Entrada'),
});
exports.schemaCurso = exports.yupCurso.shape({});
